module.exports = __webpack_public_path__ + "static/media/Model-Buttons-ZoomIn.831e1a08.svg";